// extracted by mini-css-extract-plugin
export default {"solutionText":"MathShowcase_solutionText__AGSO+"};